<style lang="scss" scoped>
@import "core";

.my-lead {
  margin-bottom: 15px;
  color: $color-strong;
}

.my-section {
  margin-top: 20px;
}

.my-small-guide {
  font-size: 90%;
}
</style>



<template>
  <error-dialog-base ref="base">
    <div slot="header">データ接続中に<wbr>予期せぬエラーが<wbr>発生しました</div>
    <div slot="message" is="template">画面を再度読み込んで頂き、再度お試しください。<br>何度かこのエラーが続く場合は以下をご確認ください。</div>
    <section class="my-section pb10">
      <h3 class="mdTtl03">ダウンロードデータのクリアをお試しください</h3>
      <p class="my-small-guide">
        以下のボタンを押してデータのクリアをお試しください。※データの再ダウンロードが必要になります
      </p>
      <p class="mt10 tac">
        <dn-btn @click="clearData" sm accent>データを削除する</dn-btn>
      </p>
<!--
      <p class="mt20">
        上記でも改善されない場合、お使いのブラウザのWEBサイトデータを一度クリアしてお試しください。

      </p>
      <my-howtoclear />
-->
    </section>

    <section class="my-section">
      <h3 class="mdTtl03">お使いのブラウザをご確認ください</h3>
      <p class="my-small-guide">以下のブラウザでこのページを表示可能です。</p>
      <my-compatibleTable />
    </section>

    <section class="my-section">
      <h3 class="mdTtl03">プライベートブラウズモードで表示されていないかご確認ください</h3>
      <p class="my-small-guide">プライベートブラウズ状態でページが表示されている場合データの保存ができません。<br>通常の状態でページを開き直してお試しください。</p>
    </section>

    <section class="my-section">
      <h3 class="mdTtl03">Cookieやストレージ機能が無効設定されていないかご確認ください</h3>
      <p class="my-small-guide">ブラウザのストレージ設定が無効化されている場合データの保存ができません。<br>お使いのブラウザごとに以下の手順をお試しください。</p>
      <my-howtocookie />
    </section>

  </error-dialog-base>
</template>



<script>
import DialogMixin from './dialogMixin';
import CompatibleTable from './partials/CompatibleTable';
import HowToCookie from './partials/HowToCookie';
// import HowToClear from './partials/HowToClear';



const DB_NAME_PREFIX = 'dn_db_';



export default {
  mixins: [DialogMixin],

  components: {
    'my-compatibleTable': CompatibleTable,
    'my-howtocookie': HowToCookie,
    // 'my-howtoclear': HowToClear,
  },

  methods: {
    clearData() {
      const dbName = `${DB_NAME_PREFIX}${dn.$store.getters['config/year']}`;
      const indexedDB = window.indexedDB || window.mozIndexedDB || window.webkitIndexedDB || window.msIndexedDB;
      const request = indexedDB.deleteDatabase(dbName);

      dn.loading.show();

      request.onerror = (event) => {
        dn.loading.hide();
        alert('データを削除できませんでした。');
      }

      request.onsuccess = event => {
        dn.$ls.delete('db_states');
        dn.loading.hide();
        setTimeout(() => {
          alert('削除に成功しました。ブラウザをリロードして再度データをダウンロードしてください。');
        }, 250);
      }
    },
  },
}
</script>



// WEBPACK FOOTER //
// DialogExceptionError.vue?0480a67a